import React, { memo, useCallback } from 'react';

import usePrefix from 'utils/usePrefix';
import { userRoles } from 'utils/userRoles';
import { getApiUrl, api } from 'utils/api';
import { useApp } from 'App';
import { ActionTypes } from 'App/types';
import colors from 'styles/colors';

import Icon from 'components/Icons';
import FlexDiv from 'components/FlexDiv';
import SetLanguage from 'components/SetLanguage';
import {
  ADVICES_URL,
  ARTICLES_URL,
  CHAT_URL,
  EXPERT_ADMIN_URL,
  EXPERT_URL,
  INSTRUCTIONS_URL,
  INTERVENTION_PLANS_URL,
  MOVIES_URL,
  NOTICES_URL,
  REPORTS_URL,
  SCHOOLS_URL,
  USERS_URL,
} from 'App/constants';

import {
  Wrapper,
  GrayLine,
  NavList,
  StyledIcon,
  StyledButton,
  StyledButtonLink,
  LogoLink,
} from './styles';
import NavigationItem from './NavigationItem';
// import AppVersion from './AppVersion';

const Navigation: React.FC = () => {
  const [{ profile }, dispatch] = useApp();
  const t = usePrefix('Navigation');

  const isAdmin = profile?.role === userRoles.admin;
  const isDirector = profile?.role === userRoles.director;
  const isResqlExpertEnabled = profile?.has_resql_expert_schools;

  const onLogout = useCallback(() => {
    const url = getApiUrl('/users/me/logout');
    api(`${url}`, { method: 'POST' }).then();

    dispatch({ type: ActionTypes.LOGOUT });
  }, [dispatch]);

  return (
    <Wrapper>
      <LogoLink to="/app">
        <Icon type="logo" width="60" height="52" color={colors.white} />
      </LogoLink>
      <GrayLine />

      <NavList>
        {(isAdmin || isDirector) && (
          <NavigationItem icon="reports" to={REPORTS_URL} label={t('reports')} />
        )}
        {isAdmin ? (
          <>
            <NavigationItem
              icon="headphones"
              to={EXPERT_ADMIN_URL}
              label={t('resql_expert_admin')}
            />
            <NavigationItem icon="repository" to={NOTICES_URL} label={t('notices')} />
          </>
        ) : (
          <>
            {isResqlExpertEnabled ? (
              <>
                <NavigationItem icon="headphones" to={EXPERT_URL} label={t('resql_expert')} />
                <NavigationItem
                  icon="bulb"
                  to={INTERVENTION_PLANS_URL}
                  label={t('intervention_plans')}
                />
              </>
            ) : null}
            <NavigationItem icon="chat" to={CHAT_URL} label={t('chat')} />
            <NavigationItem icon="lesson" to={ADVICES_URL} label={t('advices')} />
            <NavigationItem icon="material" to={INSTRUCTIONS_URL} label={t('materials')} />
            <NavigationItem icon="movie" to={MOVIES_URL} label={t('movies')} />
            <NavigationItem icon="article" to={ARTICLES_URL} label={t('articles')} />
          </>
        )}
        {isAdmin && (
          <>
            <NavigationItem icon="users" to={USERS_URL} label={t('users')} />
            <NavigationItem icon="schools" to={SCHOOLS_URL} label={t('schools')} />
          </>
        )}
      </NavList>
      <FlexDiv flexDirection="column" alignItems="center">
        <StyledButtonLink to={'profile'} bgColor={colors.black_shadow}>
          <StyledIcon type="user" margin="auto" color={colors.white} />
        </StyledButtonLink>
        <StyledButton type="button" onClick={onLogout} bgColor={colors.yellow}>
          <StyledIcon type="exit" margin="auto" color={colors.brand_2} />
        </StyledButton>
      </FlexDiv>
      <SetLanguage />
      {/*<AppVersion />*/}
    </Wrapper>
  );
};

export default memo(Navigation);
